import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { SentimentDissatisfied, Home as HomeIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NotFound: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
          textAlign: 'center',
          py: 6,
        }}
      >
        <SentimentDissatisfied
          sx={{ fontSize: 80, color: 'primary.light', mb: 3 }}
        />
        <Typography variant="h2" fontWeight={700} color="text.primary" gutterBottom>
          404
        </Typography>
        <Typography variant="h6" color="text.secondary" sx={{ mb: 4 }}>
          {t('notFound')}
        </Typography>
        <Button
          variant="contained"
          startIcon={<HomeIcon />}
          onClick={() => navigate('/dashboard')}
          size="large"
        >
          {t('organizationSetup.infoAction', 'Back to dashboard')}
        </Button>
      </Box>
    </Container>
  );
};

export default NotFound;
